import { Language } from "./language";
import { PassengerType } from "./passenger-types";

export interface Ticket {
    id: number | string;
    passengerType: PassengerType;
    price: number;
    count: number;
    overriddenPassengerTypes: CustomPassengerName[]
}

export interface LocalizedText {
    'en-US': string;
    'da-DK': string;
    [key: string]: string;
}

export interface CustomPassengerName {
    passengerType: PassengerType;  // e.g., "A" for Adult, "Y" for Young
    name: string;                  // e.g., "Odense Nu (fra 26 år)"
    language: Language
}

export interface SpecialTicketData {
    id: string;
    name: LocalizedText;
    description: LocalizedText;
    validityText: LocalizedText;
    validity: {
        startTime?: string | null;
        endTime?: string | null;
        multipleDays?: number | null;
        multipleTicketDays?: number | null;
        multipleMinutes?: number | null;
    } | null;
    usagePeriods: {
        startDate?: string | null;
        endDate?: string | null;
        startTime?: string | null;
        endTime?: string | null;
        validWeekdays: (keyof typeof ISODayOfWeek)[];
    }[];
    shouldDateBePreselected: boolean;
    pricingOptions: {
        passengerType: PassengerType;
        price: number;
    }[];
    bannerUri: string;
    status: string;
    zones: number[];
    pto: string;
    overriddenPassengerTypes: CustomPassengerName[]
}

export enum ValidityType {
    None = 'none',
    Minutes = 'minutes',
    TicketDays = 'ticketDays',
    CalendarDays = 'calendarDays',
    SpecificTime = 'specificTime'
}

export enum ISODayOfWeek {
    Monday = 1,
    Tuesday = 2,
    Wednesday = 3,
    Thursday = 4,
    Friday = 5,
    Saturday = 6,
    Sunday = 7
}